import {useQueryClient} from "react-query";
import _ from "underscore";
import {makeStyles, useTheme, withStyles} from "@material-ui/core/styles";
import {useTrips} from "../../../services/trips";
import {Tooltip} from "@material-ui/core";

const styles = (theme) => ({
  popper: {
    maxWidth: "fit-content"
  },
});

const TripUuidLookup = props => {
  const theme = useTheme();
  const classes = makeStyles(theme => ({
    readOnly: {
      color: theme.palette.text.primary
    }
  }))(theme);

  const queryClient = useQueryClient();
  const extraKeys = [props.includeScratchPads ? "findIncludingScratchpads" : "find", "trip", props.value];
  const records = useTrips({queryClient, extraKeys});

  if (props.type === "render") {
    const trip = _.find(records.data, {tripUuid: props.value});
    return (
      <Tooltip title={records.data && trip ?`${trip.tripPrefix}${trip.tripNo} ${trip.tripRoute ? `Route (${trip.tripRoute})` : ""}` : ''}>
      <div>
          {records.data && trip ?`${trip.tripPrefix}${trip.tripNo}` : ''}
      </div>
      </Tooltip>
    );
  }

  return <></>
}

export default withStyles(styles) (TripUuidLookup);
export {
  TripUuidLookup
}
